
import { mapState, mapGetters, mapActions } from 'vuex'
import PersonalMenu from '@data-fair/sd-vue/src/vuetify/personal-menu.vue'
import LangSwitcher from '@data-fair/sd-vue/src/vuetify/lang-switcher.vue'

export default {
  components: { PersonalMenu, LangSwitcher },
  props: ['navContext'],
  computed: {
    ...mapState(['env', 'breadcrumbItems', 'breadcrumbsRouteName']),
    ...mapState('session', ['user', 'initialized']),
    ...mapGetters(['missingSubscription']),
    ...mapGetters('session', ['activeAccount'])
  },
  methods: {
    ...mapActions('session', ['logout', 'login', 'switchOrganization']),
    reload () {
      window.location.reload()
    },
    setDarkCookie (value) {
      const maxAge = 60 * 60 * 24 * 100 // 100 days
      this.$cookies.set('theme_dark', '' + value, { path: '/', domain: this.env.sessionDomain, maxAge })
      this.reload()
    },
    setAdminMode (value) {
      const redirect = value ? null : this.env.publicUrl
      this.$store.dispatch('session/setAdminMode', { value, redirect })
    }
  }
}
